import { DataSetSection, IDataSetSection } from './DataSetSection';
import { IConfiguration } from '@/models/configuration/Configuration';
import { DataSetEditor } from './DataSetEditor';
import { IDataSetBase, DataSetBase } from './DataSetBase';
import { DataSetActionFieldCount } from './DataSetActionFieldCount';

export interface IDataSet extends IDataSetBase {
    unsyncedParts: boolean;
    fixedRow: boolean;
    actionItems?: DataSetActionFieldCount[];

}

export class DataSet extends DataSetBase implements IDataSet {
    public unsyncedParts: boolean;
    public fixedRow: boolean;
    public actionItems?: DataSetActionFieldCount[];


    constructor();
    // tslint:disable-next-line: unified-signatures
    constructor(obj: IDataSet);
    // tslint:disable-next-line: unified-signatures
    constructor(obj: IConfiguration);
    constructor(obj?: any) {
        super(obj);
        this.unsyncedParts = obj && obj.unsyncedParts || false;
        this.fixedRow = obj && obj.fixedRow || false;

        if (obj && obj.actionItems !== undefined) {
            this.actionItems = [];
            obj.actionItems.forEach((actionItem: any) => {
                if (this.actionItems !== undefined) {
                    this.actionItems.push(new DataSetActionFieldCount(actionItem));
                }
            });
        }

    }
}
